import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InstaServiceProductionCategory from './InstaServiceProductionCategory';

const base = 'insta-service';

@inject('ProductionStore', 'UserStore')
@observer
class InstaServiceProduction extends Component {
    render() {
        const {
            UserStore: {
                isCurrentPageFullScreen
            },
            instaServiceProductions
        } = this.props;

        const groupedByLocation = instaServiceProductions.reduce((acc, stock) => {
            stock.requests.forEach((request) => {
                if (request.status === 'COMPLETED') return;

                const rawLocation =
                    (request.insta_service_location || 'Warmer').trim();

                const normalizedLocation = rawLocation
                    .toLowerCase()
                    .replace(/\s+/g, ' ')
                    .replace(/\b\w/g, (c) => c.toUpperCase());

                if (!acc[normalizedLocation]) acc[normalizedLocation] = [];

                acc[normalizedLocation].push({
                    ...request,
                    id: stock.id,
                    created_date: stock.created_date,
                });
            });
            return acc;
        }, {});

        const allLocations = Object.keys(groupedByLocation);
        const fixedOrder = ['Warmer', 'Sous Vide', 'Chiller'];
        const otherLocations = allLocations.filter((loc) => !fixedOrder.includes(loc));
        const locations = [...fixedOrder, ...otherLocations.sort()];

        const groupedData = locations.map((location) => {
            const requests = groupedByLocation[location] || [];

            const groupedByCategory = requests.reduce((acc, req) => {
                const { category } = req;
                if (!acc[category]) {
                    acc[category] = {
                        id: req.id,
                        items: [],
                        created_date: req.created_date,
                    };
                }

                acc[category].items.push(req);

                if (
                    new Date(req.created_date) <
                    new Date(acc[category].created_date)
                ) {
                    acc[category].created_date = req.created_date;
                }

                return acc;
            }, {});

            const categories = Object.keys(groupedByCategory).map(category => ({
                id: groupedByCategory[category].id,
                category,
                created_date: groupedByCategory[category].created_date,
                items: groupedByCategory[category].items.sort((a, b) => b.quantity - a.quantity)
            })).sort((a, b) => b.items.length - a.items.length);

            return { location, categories };
        });

        return (
            <div>
                <div
                    className={`${base}__card_header top-up`}
                >
                    <div
                        className='top-up'
                    >
                        TOP UP NOW
                    </div>
                </div>
                <div 
                    className={`${
                        isCurrentPageFullScreen ? 'insta-service__card_container_full-screen' : 'insta-service__card_container'
                    }`}
                >
                    <div className={`${base}__vertical_sections`}>
                        {groupedData.map(({ location, categories }) =>
                            categories.length > 0 ? (
                                <div key={location} className={`${base}__vertical_section`}>
                                    <h2 className={`${base}__vertical_title`}>{location}</h2>

                                    {categories.map((category) => (
                                        <InstaServiceProductionCategory
                                            key={`${location}-${category.category}`}
                                            category={category}
                                            isCurrentStock={false}
                                        />
                                    ))}
                                </div>
                            ) : null
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default InstaServiceProduction;
